import React, { Fragment, useContext, useState } from 'react';
import './Sitemap.scss';
import { ViewClientT } from 'bovaljaren-models';
import FovMarker from './FovMarker/FovMarker';
import { CameraAlt, CameraOutlined } from '@material-ui/icons';
import { AppContext } from '../../../state/app.state';

type Props= {
    showSitemap: boolean;
    sitemapUrl: string;
    currentView?: ViewClientT;
    views?: ViewClientT[];
}

/**
 * Missing good implementation on how the image should be presented.
 * Needs to be implemented once we know how the drawer should look.
 */

const Sitemap: React.FC<Props> = ({ showSitemap, sitemapUrl, views, currentView }) => {

    const { state } = useContext(AppContext);
    const [loaded, setLoaded] = useState(false);

    return (
        <>{showSitemap && <div id='bv-sitemap-container'>
            <img src = {sitemapUrl} alt='' className='bv-sitemap-image' onLoad={(): void => setLoaded(true)}/>
            {loaded && views?.filter(v => v.sitemapMarker).map((v, i) => {
                if (!v || !v.sitemapMarker) {
                    return undefined;
                }

                const { scale, rotation, relativePosition, fov } = v.sitemapMarker;

                const fovRotationOffset = 135; //The constant rotation offset of the fov is 90+45 degrees.

                const getTopAdjustment = (): number => {

                    if ((rotation) < 47)
                        return 1;
                    else if ((rotation) <= 137)
                        return 0.75;
                    else if ((rotation) <= 225)
                        return 0.2;
                    else if ((rotation) <= 317)
                        return 0;
                    else
                        return 1;
                };
                const getLeftAdjustment = (): number => {

                    if ((rotation) < 47)
                        return 0.1;
                    else if ((rotation) <= 137)
                        return 0;
                    else if ((rotation) <= 225)
                        return 0.5;
                    else if ((rotation) <= 317)
                        return 0.5;
                    else
                        return 0.55;
                };

                return (<Fragment key={v.id}>
                    <FovMarker
                        key={i}
                        scale={scale}
                        viewId={v.id}
                        rotation={rotation}
                        focused = {v.id === currentView?.id}
                        fov={fov}
                        relativePosition={relativePosition}
                        onClick={(): void => state?.changeView(v.id)}
                    />
                    <CameraAlt
                        onClick={(): void => state?.changeView(v.id)}
                        className={'bv-fov-camera'}
                        style={{
                            position: 'absolute',
                            left: `calc(${relativePosition.x}% - 0.65rem)`,
                            top: `calc(${relativePosition.y }% - 0.65rem)`
                        }}/>
                </Fragment>);
            })}
        </div>}</>
    );
};


export default Sitemap;